import {useEffect, useRef, useState} from "react";
import MainLayout from "../components/MainLayout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import {useNavigate, useLocation} from "react-router-dom";
import {Button} from "primereact/button";
import {toast} from "react-toastify";
import {Dropdown} from "primereact/dropdown";
import moment from "moment";
import "moment/locale/uz";
import {BreadCrumb} from "primereact/breadcrumb";
import {
	getInvoiceById,
	postReceivingInvoice,
} from "../services/invoice.service";
import {postSerialsSehid} from "../services/misc.service";
import {getBlocksOfStorage} from "../services/block.service";

const InvoiceDetailsPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [date, setDate] = useState();
	const [invoice, setInvoice] = useState([]);
	const [seh, setSeh] = useState();
	const [loading, setLoading] = useState(false);
	const [selectedFurnitures, setSelectedFurnitures] = useState([]);
	const [blocks, setBlocks] = useState([]);
	const [selectedBlock, setSelectedBlock] = useState(null);
	const invoiceNumber = location.pathname.split("/")[2];
	const role = sessionStorage.getItem("role");
	const scannerInputRef = useRef(null);

	const handleScannerInput = (scannedId) => {
		const invoiceToSelect = invoice.find(
			(inv) => inv.unique.name === scannedId
		);
		if (invoiceToSelect) {
			setSelectedFurnitures((prev) => {
				const isAlreadySelected = prev.some(
					(item) => item.unique_id === scannedId
				);
				return isAlreadySelected ? prev : [...prev, invoiceToSelect];
			});
			toast.success(`Накладной ${scannedId} танланди`);
		} else {
			toast.error(`Накладной ${scannedId} топилмади`);
		}
		if (scannerInputRef.current) {
			scannerInputRef.current.value = "";
			scannerInputRef.current.focus();
		}
	};

	useEffect(() => {
		if (scannerInputRef.current) {
			scannerInputRef.current.focus();
		}
	}, []);

	const onSelectionChange = (e) => {
		setSelectedFurnitures(e.value);
	};

	const handleRecieve = async () => {
		try {
			const invoiceIds = selectedFurnitures.map((item) => item.unique_id);
			await postReceivingInvoice(
				parseInt(invoiceNumber),
				invoiceIds,
				selectedBlock
			);

			toast.success("Накладнойлар қабул қилинди");
			navigate("/recieve");
		} catch (error) {
			console.log(error);
			toast.error("Накладнойларни қабул қилишда хатолик");
		}
	};

	useEffect(() => {
		const fetchVipusk = async () => {
			setLoading(true);
			const invoiceRes = await getInvoiceById(invoiceNumber);
			const invoiceData = invoiceRes;
			const vipuskRes = await postSerialsSehid(invoiceData.seh_id);
			const blocksRes = await getBlocksOfStorage();

			const invoiceUniques = vipuskRes.serials.filter((item) =>
				invoiceData.uniques.some((inv) => inv.id === item.unique_id)
			);

			setBlocks(blocksRes.blocks);
			setDate(moment(invoiceData.date).format("D MMMM YYYY"));
			setSeh(invoiceData.seh);
			setInvoice(invoiceUniques);
			setLoading(false);
		};

		fetchVipusk();
	}, [invoiceNumber]);

	// useEffect(() => {
	//   let scannedCode = "";
	//   const handleBarcodeScan = (event) => {
	//     scannedCode += event.key;

	//     if (event.key === "Enter") {
	//       const trimmedCode = scannedCode.trim();
	//       const matchingInvoice = invoice.find((item) => item.unique.name === trimmedCode);
	//       if (matchingInvoice) {
	//         setSelectedFurnitures((prev) =>
	//           prev.some((item) => item.unique_id === matchingInvoice.unique_id)
	//             ? prev
	//             : [...prev, matchingInvoice]
	//         );
	//       }
	//       scannedCode = "";
	//     }
	//   };

	//   window.addEventListener("keydown", handleBarcodeScan);
	//   return () => window.removeEventListener("keydown", handleBarcodeScan);
	// }, [invoice]);

	const item = [
		{
			label: "Складга қабул қилиш",
			template: () => (
				<span className="cursor-pointer" onClick={() => navigate("/recieve")}>
					Складга қабул қилиш
				</span>
			),
		},
		{
			label: "Қабул қилиш",
			template: () => (
				<span className="font-semibold cursor-pointer">Қабул қилиш</span>
			),
		},
	];

	return (
		<MainLayout header={`Накладной №${invoiceNumber}`}>
			<div>
				<BreadCrumb model={item} className="px-0 pt-0 pb-8" />
				{/* Hidden Scanner Input */}
				<InputText
					ref={scannerInputRef}
					style={{position: "absolute", left: "-9999px"}}
					autoFocus
					readOnly={true}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							e.preventDefault();
							const scannedId = e.target.value.trim();
							handleScannerInput(scannedId);
						}
					}}
					onBlur={() => scannerInputRef.current?.focus()}
				/>
				<div className="pt-0 pb-6">
					<div className="flex w-full">
						<div className="flex flex-col w-full mr-8">
							<label className="mb-1 text-sm font-medium text-gray-700">
								Склад блок
							</label>
							<Dropdown
								value={selectedBlock}
								options={blocks.map((block) => ({
									label: block.name,
									value: block.id,
								}))}
								onChange={(e) => setSelectedBlock(e.value)}
								className="w-full border"
								placeholder="Блокни танланг"
								disabled={loading}
							/>
						</div>
						<div className="flex flex-col mr-8 w-fit">
							<label className="mb-1 text-sm font-medium text-gray-700">
								Накладной раками
							</label>
							<InputText
								value={invoiceNumber || ""}
								className="px-4 py-2 border"
								disabled
							/>
						</div>
						<div className="flex flex-col w-full mr-8">
							<label className="mb-1 text-sm font-medium text-gray-700">
								Сех
							</label>
							<InputText
								value={seh || ""}
								className="w-full px-4 py-2 border"
								disabled
							/>
						</div>
						<div className="flex flex-col w-full">
							<label className="mb-1 text-sm font-medium text-gray-700">
								Накладной санаси
							</label>
							<InputText
								value={date || ""}
								className="w-full px-4 py-2 border"
								disabled
							/>
						</div>
						{role === "sklad_rahbari" && (
							<div className="flex items-end w-full">
								<Button
									label="Қабул қилиш"
									className="h-[42px] text-white min-w-[100px] bg-blue rounded-md hover:bg-opacity-90 w-[200px] ml-4"
									onClick={handleRecieve}
									disabled={!selectedFurnitures.length}
								/>
							</div>
						)}
					</div>
				</div>
				<DataTable
					className="custom-row-border"
					value={invoice}
					rows={10}
					rowsPerPageOptions={[5, 10, 25, 50]}
					loading={loading}
					selectionMode="multiple"
					selection={selectedFurnitures}
					onSelectionChange={onSelectionChange}>
					{role === "sklad_rahbari" && (
						<Column selectionMode="multiple" headerStyle={{width: "3rem"}} />
					)}
					<Column
						field=""
						header="N"
						headerClassName="w-fit"
						body={(_, {rowIndex}) => rowIndex + 1}
					/>
					<Column field="unique.name" header="Уникал номер" />
					<Column
						field=""
						header="Клиент"
						body={(rowData) =>
							rowData.demand_furniture_id
								? rowData.demand_furniture.demand.customer.name
								: "Супермаркет"
						}
					/>
					<Column
						field=""
						header="Комплект"
						body={(rowData) =>
							`${rowData.furniture.category_furniture.name} ${rowData.furniture.komplekt_furniture[0].komplekt.name}`
						}
					/>
					<Column field="furniture.name" header="Мебель" />
					<Column field="amount" header="Сони" />
				</DataTable>
			</div>
		</MainLayout>
	);
};

export default InvoiceDetailsPage;
